import { useTheme } from '@emotion/react';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import { Badge, Grid, Tooltip } from '@mui/material';
import AryFileUploaderNewDesign from 'framework/base/components/AryFileUploaderPreview/AryFileUploaderNewDesign';

import AryLoadingButton from 'framework/base/components/AryLoadingButton';
import AryModal from 'framework/base/components/AryModal';
import useLayoutTypeContext from 'framework/base/hooks/useLayoutTypeContext';
import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import React, { useEffect, useState } from 'react';
import AryIconButton from './AryIconButton';

export default function AryFileUploaderModal({
  fileIds,
  removedFileIds,
  handleRemovedFileIds,
  onUploadFiles,
  files,
  readOnly
}) {
  const theme = useTheme();
  const { t } = useFrameworkTranslation();
  const [openModal, setOpenModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(files);
  const [savedFileIds, setSaveFileIds] = useState(fileIds);
  const [isImgPreviewShow, setIsImgPreviewShow] = useState(false);
  const layoutType = useLayoutTypeContext();

  const handleSavedFileIds = (newState) => {
    setSaveFileIds(newState);
  };
  const handleSetIsImgPreviewShow = (newState) => {
    setIsImgPreviewShow(newState);
  };
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const form = e.target.closest('form');
      if (form) {
        form.requestSubmit();
      }
    }
  };
  useEffect(() => {
    setSaveFileIds(fileIds);
  }, [fileIds]);
  return (
    <>
      <Tooltip
        title={t('Upload File')}
        placement="bottom"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: '#344456',
              borderRadius: '4px',
              '& .MuiTooltip-arrow': {
                color: '#344456'
              }
            }
          }
        }}
      >
        <Badge
          badgeContent={(files?.length || 0) + (fileIds?.length || 0)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          sx={{
            '& .MuiBadge-badge': {
              color: '#fff',
              backgroundColor: readOnly
                ? theme.icon.grey200.color
                : theme.text.primary600.color
            }
          }}
        >
          <AryIconButton
            onClick={() => setOpenModal(true)}
            onKeyDown={handleKeyDown}
            borderColor={
              readOnly ? theme.icon.grey200.color : theme.text.primary500.color
            }
            focusStyles={{
              borderColor:
                files?.length || fileIds?.length
                  ? theme.sidebar.active.blueBg.background
                  : theme.sidebar.blueBackground,
              boxShadow:
                files?.length || fileIds?.length
                  ? '0px 2px 3px 1px #051C3126, 0px 2px 2px 0px #051C314D'
                  : '0px 2px 3px 1px #051C3126,0px 2px 4px 0px #051C314D',
              background:
                files?.length || fileIds?.length ? '#AFD4E9' : '#E0EEF6',
              icon:
                files?.length || fileIds?.length
                  ? theme.sidebar.blueBackground
                  : theme.text.primary600.color
            }}
            sx={{
              width: layoutType === 'mobile' ? '3rem' : '2rem',
              height: layoutType === 'mobile' ? '3rem' : '2rem',
              bgcolor:
                files?.length || fileIds?.length
                  ? readOnly
                    ? theme.icon.grey50.color
                    : theme.select.selectedOption.backgroundColor
                  : 'transparent',
              '&:hover': {
                boxShadow:
                  files?.length || fileIds?.length
                    ? '0px 1px 2px 0px #051C3114, 0px 1px 3px 0px #051C3126'
                    : '0px 1px 2px 0px #051C3114, 0px 1px 3px 0px #051C3126',
                bgcolor:
                  files?.length || fileIds?.length
                    ? theme.chip.primary.background
                    : theme.wrapper.blueBackground.color
              }
            }}
            disabled={readOnly}
            Icon={AttachFileRoundedIcon}
            iconColor={
              files?.length || fileIds?.length
                ? '#003E74'
                : theme.text.primary500.color
            }
            disabledIconColor={theme.text.primary200.color}
          />
        </Badge>
      </Tooltip>
      {openModal && (
        <AryModal
          open={openModal}
          handleClose={() => {
            setOpenModal(false);
            setUploadedFiles(files);
            setSaveFileIds(fileIds);
          }}
          title={t('Upload File')}
          justifyContent="center"
          columnSpacing="0"
          width={isImgPreviewShow ? '100vw' : '27rem'}
          height={isImgPreviewShow ? '100vh' : 'auto'}
          style={{
            padding: '1.5rem 1.75rem !important',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100vw',
            maxHeight: '100vh',
            alignItem: 'center'
          }}
          noCloseOnOutsideClicked
        >
          <Grid
            item
            padding="0 !important"
            width="100%"
            height="100%"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
          >
            <AryFileUploaderNewDesign
              fileIds={savedFileIds}
              removedFileIds={removedFileIds}
              handleRemovedFileIds={(newFileIds) => {
                handleRemovedFileIds(newFileIds);
              }}
              handleSavedFileIds={handleSavedFileIds}
              files={uploadedFiles}
              onChange={(newFiles) => {
                setUploadedFiles(newFiles);
              }}
              initialPreviews={files}
              readOnly={readOnly}
              handleSetIsImgPreviewShow={handleSetIsImgPreviewShow}
            />
            <Grid item mt={4}>
              <AryLoadingButton
                variant="contained"
                size="small"
                type="submit"
                onClick={() => {
                  onUploadFiles(uploadedFiles, savedFileIds);
                  setOpenModal(false);
                }}
              >
                {t('Submit')}
              </AryLoadingButton>
            </Grid>
          </Grid>
        </AryModal>
      )}
    </>
  );
}
